export default __webpack_public_path__ + "static/media/Tafe.296a3bb3.png";